const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// The platform CDN in front of the app only caches paths that look like static
// files, so images are requested at .webp/.jpg twins of the API routes:
//   /api/library/{id}/cover?v=x     -> /api/img/cover/{id}.webp?v=x&size=…
//   /api/content/image/{key}?v=x    -> /api/img/content/{key}.webp?v=x&size=…
// The extension states the format, so each URL is one set of bytes — safe to cache.
const canWebp = () => {
  try {
    return document.createElement("canvas").toDataURL("image/webp").startsWith("data:image/webp");
  } catch {
    return false;
  }
};
const EXT = typeof document === "undefined" || canWebp() ? "webp" : "jpg";

const fileUrl = (src, size) => {
  const [path, query = ""] = src.split("?");
  const q = query ? `${query}&size=${size}` : `size=${size}`;
  const cover = path.match(/^\/api\/library\/([^/]+)\/cover$/);
  if (cover) return `${BACKEND_URL}/api/img/cover/${cover[1]}.${EXT}?${q}`;
  const content = path.match(/^\/api\/content\/image\/(.+)$/);
  if (content) return `${BACKEND_URL}/api/img/content/${content[1]}.${EXT}?${q}`;
  return null;
};

// Stored artwork is referenced as "/api/…?v={hash}". The version makes the URL
// immutable, so we can ask for a right-sized variant and cache it for a year;
// replacing the image changes the version.
export const coverSrc = (src, size = "thumb") => {
  if (!src) return "";
  if (!src.startsWith("/api/")) return src;
  return fileUrl(src, size) || `${BACKEND_URL}${src}&size=${size}`;
};

// Heroes are full-bleed, so phones can take a much lighter file.
export const heroSrcSet = (src) => {
  if (!src || !src.startsWith("/api/")) return undefined;
  return `${coverSrc(src, "hero_sm")} 1100w, ${coverSrc(src, "hero")} 1800w`;
};
